import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { ActionCardComponent } from '../../atoms/cards/action-card/action-card.component';

@Component({
  selector: 'ui-events-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ActionCardComponent, TranslocoDirective],
  template: `
    <ng-container *transloco="let t">
      <ui-action-card
        icon="notification"
        [items]="eventsItems()"
        [label]="t('EVENTS.LABEL')"
        [iconClass]="
          (eventsUnreadCount() ?? 0) <= 0
            ? 'text-blue bg-blue-light shadow-custom-blue'
            : 'text-error bg-error-light shadow-custom-error'
        "
        (linkClick)="handleEventsLinkClick()"
      />
    </ng-container>
  `,
})
export class EventsCardComponent {
  private translocoService = inject(TranslocoService);

  eventsUnreadCount = input<number | null>(null);
  eventsLinkClick = output<void>();

  eventsItems = computed(() => this.getLocalizeEventsItems());
  eventsUnreadLabel = toSignal(
    this.translocoService.selectTranslate('DISTRIBUTION_NETWORK.HEADER.UNREAD'),
  );

  getLocalizeEventsItems() {
    return [
      {
        label: this.eventsUnreadLabel(),
        count: this.eventsUnreadCount(),
        class: (this.eventsUnreadCount() ?? 0) <= 0 ? 'text-blue' : 'text-error',
      },
    ];
  }

  handleEventsLinkClick() {
    this.eventsLinkClick.emit();
  }
}
